import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Outcometrip() {
  return (
    <section className="outcome_trip p-100 text_trip">
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>
              What were the <span>Outcomes?</span>
            </h2>
            <p>
              Our work resulted in an error and bug-free mobile and web
              applications and admin panel with complete support for
              stakeholders, a working payment process, and Apple Pay and
              multiple currency support.
            </p>
            <div className="outcome_trip_img">
              <StaticImage
                src="../../../images/case-studies/equi-trip/outcome_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={1135}
                height={564}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Outcometrip;
